<section id="schedaPartner" class="content-padding darker">
  <div class="narrow-wrapper">
      <form class="has-cols" [formGroup]="teamLeaderForm" (ngSubmit)="onSubmit()" *ngIf="teamLeaderForm">

          <div class="col-48 grid-element" formGroupName="user">
              <label>Cognome{{ teamLeaderForm.get('user').get("surname") | required }}</label>
              <input type="text" name="surname" formControlName="surname">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('user').get('surname')" [messages]="formValidationMsgs.user.surname"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" formGroupName="user">
              <label>Nome{{ teamLeaderForm.get('user').get("name") | required }}</label>
              <input type="text" name="name" formControlName="name">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('user').get('name')" [messages]="formValidationMsgs.user.name"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" formGroupName="user">
              <label for="emailExpert">E-mail{{ teamLeaderForm.get('user').get('email') | required }}</label>
              <input type="email" name="email" formControlName="email">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('user').get('email')" [messages]="formValidationMsgs.user.email"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
              <label for="telefonoExpert">Telefono{{ teamLeaderForm.get("phone") | required }}</label>
              <input type="text" name="phone" formControlName="phone">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
          </div>

          <div class="grid-element-full">
              <label for="indirizzoExpert">
                Indirizzo{{ teamLeaderForm.get("address") | required }}
                <span class="directions" (click)="directions($event)"><i class="fas fa-directions"></i></span>
              </label>
              <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="teamLeaderForm.get('address')"></app-google-maps-search>
              <app-error-html-handler [ctrl]="teamLeaderForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
          </div>

          <!-- <div class="grid-element-full">
            <label>Scegli la Provincia</label>
            <ng-select formControlName="province">
                <ng-option *ngFor="let province of provinces" [value]="province.id">
                    <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                </ng-option>
            </ng-select>
            <app-error-html-handler [ctrl]="teamLeaderForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
          </div> -->

          <div class="grid-element-full" *ngIf="groups.includes('admin')">
            <label style="position: relative; top: 20px;">Province{{ teamLeaderForm.get('teamLeaderProvinces')?.controls[0]?.controls?.province?.id | required }}*</label>
            <div formArrayName="teamLeaderProvinces">
              <div class="offer-products" *ngFor="let provinceForm of teamLeaderForm.get('teamLeaderProvinces').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeTeamLeaderProvince(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="province">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                         <ng-select formControlName="id">
                          <ng-option *ngFor="let province of provinces" [value]="province.id" [disabled]="isTeamLeaderProvinceOptionDisabled(province)">
                            <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="provinceForm?.controls?.province?.controls?.id"
                    [messages]="formValidationMsgs?.teamLeaderProvinces?.province?.id">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addTeamLeaderProvince()">
                Aggiungi Province<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>

          <div class="col-48 grid-element">
              <label for="noteExpert">Note{{ teamLeaderForm.get("notes") | required }}</label>
              <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
          </div>

          <br class="clear">

          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
              <label>Password</label>
              <input type="password" name="password1" formControlName="password1">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('user').get('password1')" [messages]="formValidationMsgs.user.password1"> </app-error-html-handler>
          </div>
          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
              <label>Ripeti password</label>
              <input type="password" name="password2" formControlName="password2">
              <app-error-html-handler [ctrl]="teamLeaderForm.get('user').get('password2')"[messages]="formValidationMsgs.user.password2"></app-error-html-handler>
          </div>

          <br class="clear">

          <div class="center mt-20">
              <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!teamLeaderForm?.valid || tmpBtnDisabled" >
                Salva<i class="ml-10 far fa-save"></i>
              </button>
          </div>

      </form>
      <br class="clear">
  </div>
</section>
